/**
 * Utility to detect if the app is running in a WebView (native mobile app)
 * vs regular mobile web browser
 */

 export const fetchKeyFromCookie = (key) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};
export const isWebView = () => {
  const platform=fetchKeyFromCookie("platform");
  if(platform=="Android_mv" || platform=="iOS_mv") return true;
  return false;
};

export const isMobileWeb = () => {
  const width = window.innerWidth;
  return width <= 768 && !isWebView();
};

export const isDesktopWeb = () => {
  const width = window.innerWidth;
  return width > 768;
};

export const getDeviceType = () => {
  if (isWebView()) return 'NATIVE_WEBVIEW';
  if (isMobileWeb()) return 'MOBILE_WEB';
  if (isDesktopWeb()) return 'DESKTOP_WEB';
  return 'UNKNOWN';
};